import {
  FEATURE_FLAG_EXPIRY_DATE,
  USER_CREATION_CUTOFF_DATE
} from "./constants";
import { PromoFeatureName, PromoShouldApplyData, PromoType } from "./types";
import moment from "moment";
import { track } from "shared/telemetry/track";

const checkCombinedIncomePromo = ({
  isBoomScreen,
  partnerCreatedAt,
  featureFlagEnabled,
  sessionPromoData
}: PromoShouldApplyData) => {
  const now = moment();
  const shouldHide = !!Number(sessionPromoData);

  if (
    !isBoomScreen ||
    now.isAfter(FEATURE_FLAG_EXPIRY_DATE) ||
    (partnerCreatedAt
      ? moment(partnerCreatedAt).isAfter(USER_CREATION_CUTOFF_DATE)
      : false)
  )
    return false;

  return Boolean(featureFlagEnabled && !shouldHide);
};

const RULES_PER_FEATURE = {
  [PromoFeatureName.CombinedIncome]: {
    [PromoType.Modal]: {
      shouldApply: checkCombinedIncomePromo
    },
    [PromoType.Banner]: {
      shouldApply: checkCombinedIncomePromo
    }
  }
};

export const shouldApplyPromo = (
  featureName: PromoFeatureName,
  type: PromoType,
  context: PromoShouldApplyData
) => RULES_PER_FEATURE[featureName][type].shouldApply(context);

export const cleanupPromoStorage = (featureName: PromoFeatureName) => {
  sessionStorage.removeItem("hidePromoModal");
  sessionStorage.removeItem("hidePromoBanner");
  localStorage.removeItem(`${featureName}_promoBannerSeenCount`);
};

export const markPromoAsSeen = (
  featureName: PromoFeatureName,
  type: PromoType
) => {
  const promoBannerSeenCount = localStorage.getItem(
    `${featureName}_promoBannerSeenCount`
  );
  let featureFlagPersonProperties:
    | { seen_count: number }
    | { seen_modal: boolean };

  if (type === PromoType.Modal) {
    sessionStorage.setItem("hidePromoModal", "1");
    featureFlagPersonProperties = {
      seen_modal: true
    };
  } else {
    const seenBannerCount = Number(promoBannerSeenCount) + 1;

    localStorage.setItem(
      `${featureName}_promoBannerSeenCount`,
      `${seenBannerCount}`
    );
    featureFlagPersonProperties = {
      seen_count: seenBannerCount
    };
  }

  sessionStorage.setItem("hidePromoBanner", "1");
  track(`promo.${featureName}.${type}.close`, featureFlagPersonProperties);
};

export const trackPromoRUM = (
  featureName: PromoFeatureName,
  type: PromoType,
  actionType: "show" | "action-click" | "close-click"
) => {
  if (actionType === "show") track(`promo.${featureName}.show`, { type });
  if (actionType === "action-click")
    track(`promo.${featureName}.watch_demo`, { type });
};
